import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../scripts/control';
import '../../css/BdStyles.css';

const BdSeriesDetail = () => {
    const { idSeries } = useParams();
    const { idSeriesTag } = useParams();
    const navigate = useNavigate();
    const [series, setSeries] = useState(null);
    const [tag, setTag] = useState(null);
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState(null); 
    const [tagDetails, setTagDetails] = useState(null); 
    const [showModal, setShowModal] = useState(false); 
    const [credits, setCredits] = useState([{ label: '', value: '' }]);
    const [articles, setArticles] = useState([{ label: '', detail: '' }]);

    useEffect(() => {
        const fetchSeries = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdSeries_func.php?idSeries=${idSeries}`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
    
                const tagsData = Array.isArray(data.tags) ? data.tags : [];
                setTags(tagsData);
                const seriesList = data.series || [];
                const foundSeries = seriesList[0] || null;
    
                if (foundSeries) {
                    // Convertir tags a array
                    if (typeof foundSeries.tags === 'string') {
                        foundSeries.tags = foundSeries.tags.split(', ').map(tag => tag.trim());
                    } else if (!Array.isArray(foundSeries.tags)) {
                        foundSeries.tags = [];
                    }

                    // Procesar créditos
                    if (foundSeries.credits) {
                        const creditsArray = foundSeries.credits.split('||').map(item => {
                            const parts = item.split('::');
                            return parts.length === 2 ? { credit_label: parts[0], credit_value: parts[1] } : null;
                        }).filter(item => item !== null);
                        foundSeries.credits = creditsArray;
                        setCredits(creditsArray);
                    } else {
                        foundSeries.credits = [];
                        setCredits([]);
                    }

                    // Procesar artículos
                    if (foundSeries.articles) {
                        const articlesArray = foundSeries.articles.split('||').map(item => {
                            const parts = item.split('::');
                            return parts.length === 2 ? { articleLabel: parts[0], articleDetail: parts[1] } : null;
                        }).filter(item => item !== null);
                        foundSeries.articles = articlesArray;
                        setArticles(articlesArray);
                    } else {
                        foundSeries.articles = [];
                        setArticles([]);
                    }
    
                    // Construir detalles de etiquetas
                    const tagDetailsByName = {};
                    tagsData.forEach(tag => {
                        if (foundSeries.tagsDetails && foundSeries.tagsDetails[tag.idTag]) {
                            tagDetailsByName[tag.tagName] = foundSeries.tagsDetails[tag.idTag];
                        }
                    });
    
                    foundSeries.tagsDetails = tagDetailsByName;
                    setSeries(foundSeries);
                } else {
                    setSeries(null);
                }
            } catch (error) {
                setSeries(null);
            }
        };
    
        fetchSeries();
    }, [idSeries]);

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdSeries_func.php?fetchTags=true`);
                const data = await response.json();
                const tags = Array.isArray(data.tags) ? data.tags : [];
            
                const foundTag = tags.find(tag => tag.idTag === idSeriesTag); 
            
                setTag(foundTag || null);
            } catch (error) {
            }
        };
    
        if (idSeriesTag) {
            fetchTags();
        }
    }, [idSeriesTag]);

    const handleTagClick = (tagName) => {
        const tag = tags.find(t => t.tagName === tagName);
        if (tag) {
            setSelectedTag(tag);
            setTagDetails(series.tagsDetails[tagName] || '');
            setShowModal(true);
        }
    };

    // Función para parsear episodesPerSeason
    const parseEpisodesPerSeason = (episodesPerSeason) => {
        if (!episodesPerSeason) return [];
        try {
            // Intentar parsear como JSON
            const parsed = JSON.parse(episodesPerSeason);
            if (typeof parsed === 'object') {
                return Object.entries(parsed).map(([season, episodes]) => ({
                    season: parseInt(season),
                    episodes: parseInt(episodes)
                }));
            }
        } catch (e) {
            // Si no es JSON, intentar como string separado por comas
            const parts = episodesPerSeason.split(',');
            return parts.map((episodes, index) => ({
                season: index + 1,
                episodes: parseInt(episodes.trim()) || 0
            }));
        }
        return [];
    };

    if (!series) {
        return <div>Cargando detalles...</div>;
    }
    
    const episodesData = parseEpisodesPerSeason(series.episodesPerSeason);
    
    return (
        <div className="bd">
        <div className="container">
            <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
                Volver
            </button>
            <div className="card">
                <img
                    src={`${API_BASE_URL}/public/uploads/images/${series.img_url}`}
                    alt={series.seriesName}
                    className="card-img-top"
                    loading="lazy"
                />
                <div className="card-body">
                    <h2>{series.seriesName}</h2>
                    <p><strong>Año:</strong> {series.seriesYear}</p>
                    <p><strong>Clasificación:</strong> {series.seriesAge}</p>
                    <p><strong>Temporadas:</strong> {series.numSeasons || 'N/A'}</p>
                    <p><strong>Duración por capítulo:</strong> {series.episodeDuration ? `${series.episodeDuration} minutos` : 'N/A'}</p>
                    <p><strong>Total de capítulos:</strong> {series.totalEpisodes || 'N/A'}</p>
                    
                    {episodesData.length > 0 && (
                        <div>
                            <p><strong>Capítulos por temporada:</strong></p>
                            <ul>
                                {episodesData.map((item, index) => (
                                    <li key={index}>
                                        Temporada {item.season}: {item.episodes} capítulos
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    
                    <p>
                      <strong>Sinopsis:</strong> {series.synopsis}
                    </p>
                    <p>
                      <strong>Estructura:</strong> {series.structure}
                    </p>
                    <p><strong>Etiquetas:</strong></p>
                    <div>
                        {series.tags?.map((tag, index) => (
                        <button
                            key={index}
                            className="btn btn-outline-primary me-2 mb-2"
                            onClick={() => handleTagClick(tag)}
                        >
                            {tag}
                        </button>
                    ))}
                    </div>
                    <br></br>
                    { credits?.length > 0 && (
                    <div className="series-credits">
                        <h4>Créditos</h4>
                        {credits.map((credit, index) => (
                            <div key={index}>
                                <strong>{credit.credit_label}:</strong> {credit.credit_value}
                            </div>
                        ))}
                    </div>
                    )}
                    { articles?.length > 0 && (
                    <div className="series-articles">
                        <h4>Artículos relacionados</h4>
                        {articles.map((article, index) => (
                            <div key={index}>
                                <strong>{article.articleLabel}:</strong> {article.articleDetail}
                            </div>
                        ))}
                    </div>
                    )}
                </div>
            </div>
        </div>
        </div>
    );
};

export default BdSeriesDetail;

